var map = {
	"./views/nav": [
		5502,
		502
	],
	"./views/nav.vue": [
		5502,
		502
	],
	"./views/town": [
		4230,
		230
	],
	"./views/town.vue": [
		4230,
		230
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5378;
module.exports = webpackAsyncContext;